module.exports = __webpack_public_path__ + "media/images/phone-benefits-dc3d6e195b39f26f831762b91e47138c.png";